import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatBadgeModule } from '@angular/material/badge';
import { MatIconModule } from '@angular/material/icon';
import { Observable } from 'rxjs';
import { WorkOrdersRepository } from '../workorders.repository';
import { WorkOrdersQuery } from '../state/workorders.query';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-workorders-state-filter',
  standalone: true,
  imports: [CommonModule, RouterModule, MatButtonModule, MatIconModule, MatBadgeModule, TranslateModule],
  templateUrl: './workorders-state-filter.component.html',
  styleUrls: ['./workorders-state-filter.component.scss'],
})
export class WorkordersStateFilterComponent implements OnInit {
  selectedState$: Observable<string | null>;
  unassignedStateCounter$: Observable<number | null>;
  assignedStateCounter$: Observable<number | null>;
  workingStateCounter$: Observable<number | null>;
  validatedStateCounter$: Observable<number | null>;
  finishedStateCounter$: Observable<number | null>;

  constructor(private repo: WorkOrdersRepository, private workOrdersQuery: WorkOrdersQuery) {
    this.selectedState$ = this.workOrdersQuery.selectState$;
    this.unassignedStateCounter$ = this.workOrdersQuery.getCounterByState('Unassigned');
    this.assignedStateCounter$ = this.workOrdersQuery.getCounterByState('Assigned');
    this.workingStateCounter$ = this.workOrdersQuery.getCounterByState('Working');
    this.finishedStateCounter$ = this.workOrdersQuery.getCounterByState('Finished');
    this.validatedStateCounter$ = this.workOrdersQuery.getCounterByState('Validated');
  }

  ngOnInit(): void {
    this.repo.loadWorkOrders();
  }

  setFilterState(state: string) {
    this.repo.updateStateFilter(state);
  }
}
